import { render, staticRenderFns } from "./_BackgroundForm.vue?vue&type=template&id=74975a08&scoped=true&"
import script from "./_BackgroundForm.vue?vue&type=script&lang=ts&"
export * from "./_BackgroundForm.vue?vue&type=script&lang=ts&"
import style0 from "./_BackgroundForm.vue?vue&type=style&index=0&id=74975a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74975a08",
  null
  
)

export default component.exports